
import Vue from 'vue';
import { GrecaptchaEnterprise, loadRecaptchaEnterprise, resetRecaptchaWidget } from '@/services/humanCheck';

// The reCAPTCHA Enterprise checkbox. Emits `input` with the token once solved, and null when it expires or errors.
export default Vue.extend({
	name: 'RecaptchaCheckbox',
	props: {
		sitekey: { type: String, required: true },
	},
	data () {
		return {
			loadFailed: false,
			widgetId: null as number | null,
			destroyed: false,
		};
	},
	async mounted () {
		const enterprise: GrecaptchaEnterprise | null = await loadRecaptchaEnterprise();
		if (this.destroyed) return;
		const container = this.$refs.container as HTMLElement | undefined;
		if (!enterprise || !container) {
			this.onError();
			return;
		}
		try {
			this.widgetId = enterprise.render(container, {
				'sitekey': this.sitekey,
				'theme': 'dark',
				'callback': (token: string) => this.emitInput(token),
				'expired-callback': () => this.emitInput(null),
				'error-callback': () => this.onError(),
			});
		} catch (e) {
			console.error('reCAPTCHA render failed', e);
			this.onError();
		}
	},
	beforeDestroy () {
		this.destroyed = true;
	},
	methods: {
		emitInput (response: string | null) {
			this.$emit('input', response);
		},
		onError () {
			this.loadFailed = true;
			this.emitInput(null);
		},
		// Clears a solved checkbox so the person can try again (e.g. after the server rejected the token)
		reset () {
			if (this.widgetId !== null) resetRecaptchaWidget(this.widgetId);
		},
	},
});
